import React from 'react';

const ShimmerCircle = () => {
  return (
    <div class="animate-pulse relative h-full w-full">
      <div class="rounded-full bg-gray-400 absolute h-full w-full"></div>
    </div>
  );
};

export default ShimmerCircle;
